import { render, staticRenderFns } from "./DeckCard.vue?vue&type=template&id=10a3d5ff&scoped=true&"
import script from "./DeckCard.vue?vue&type=script&lang=js&"
export * from "./DeckCard.vue?vue&type=script&lang=js&"
import style0 from "./DeckCard.vue?vue&type=style&index=0&id=10a3d5ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3d5ff",
  null
  
)

export default component.exports